import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AccountSelectionComponent } from '../account-selection/account-selection.component';
import { FacadeService } from 'src/app/shared/service-facade/facade.service';

@Component({
  selector: 'app-select-accounts',
  templateUrl: './select-accounts.component.html',
  styleUrls: ['./select-accounts.component.css']
})
export class SelectAccountsComponent implements OnInit, AfterViewInit {
  @ViewChild(AccountSelectionComponent) accountSelectionComponent!: AccountSelectionComponent;

  constructor(
    private _facade: FacadeService
  ) { }

  ngOnInit(): void {
    this._facade.disableBackButton();
  }

  ngAfterViewInit(): void {
    this.accountSelectionComponent.addAccountSelector(
      this._facade.getStorageItem("productUid")
    );
    setTimeout(() => {
      window.scroll({top: 0, behavior: 'smooth'});
    }, 0);
  }

}
